import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BannerData {
  message: string;
  type: 'success' | 'like' | 'error' | 'dislike' | string; // Añade 'dislike'
}

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  private bannerDataSource = new BehaviorSubject<BannerData | null>(null); // Permite null para ocultar el banner
  bannerData$ = this.bannerDataSource.asObservable();

  showBanner(bannerData: BannerData) {
    this.bannerDataSource.next(bannerData);
    setTimeout(() => {
      this.bannerDataSource.next(null); // Oculta el banner después de 3 segundos
    }, 3000);
  }
}